"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearCookie = exports.getCookie = exports.setCookie = void 0;
var browser_1 = require("./browser");
var setCookie = function (_a) {
    var name = _a.name, value = _a.value, expiresInSeconds = _a.expiresInSeconds, domain = _a.domain, secure = _a.secure, _b = _a.path, path = _b === void 0 ? '/' : _b;
    if (!(0, browser_1.isBrowser)()) {
        throw new Error('Cannot set cookie on server');
    }
    var cookie = "".concat(name, "=").concat(value, ";path=").concat(path);
    if (domain)
        cookie = "".concat(cookie, ";domain=").concat(domain);
    if (expiresInSeconds)
        cookie = "".concat(cookie, ";max-age=").concat(expiresInSeconds);
    if (secure)
        cookie = "".concat(cookie, ";secure");
    document.cookie = cookie;
};
exports.setCookie = setCookie;
var getCookie = function (name) {
    if (!(0, browser_1.isBrowser)())
        return null;
    var cookie = document.cookie
        .split('; ')
        .find(function (c) { return c.startsWith(name); });
    if (!cookie)
        return null;
    return cookie.split('=')[1];
};
exports.getCookie = getCookie;
var clearCookie = function (_a) {
    var name = _a.name, domain = _a.domain;
    if (!(0, browser_1.isBrowser)()) {
        throw new Error('Cannot clear cookie on server');
    }
    var cookie = "".concat(name, "=; expires=Thu, 01 Jan 1970 00:00:00 GMT");
    if (domain)
        cookie = "".concat(cookie, ";domain=").concat(domain);
    document.cookie = cookie;
};
exports.clearCookie = clearCookie;
//# sourceMappingURL=cookies.js.map